import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Template = () => {
  return (
    <Box>
      <Paper elevation={0} sx={{ borderRadius: '24px', padding: '24px' }}>
        <Typography variant="h5" fontWeight={600} mb={2}>
          Template Management
        </Typography>
        <Typography color="text.secondary">
          Template management page - Coming soon
        </Typography>
      </Paper>
    </Box>
  );
};

export default Template;
